/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-boolean-value */
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import { useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Swal from 'sweetalert2';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styled from "styled-components";
import ReactFileReader from "react-file-reader";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { instance } from '../../config/Http';

export const AvatarInput = styled.div`
  margin-bottom: 32px;
  position: relative;
  align-self: center;
  img {
    width: 186px;
    height: 186px;
    object-fit: cover;
    border-radius: 50%;
  }
  .circle {
    width: 186px;
    height: 186px;
    border-radius: 50%;
  }
  label {
    right: 23em !important;
    position: absolute;
    width: 48px;
    height: 48px;
    background: #312e38;
    border-radius: 50%;
    right: 0;
    bottom: 0;
    border: 0;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      display: none;
    }
    svg {
      width: 20px;
      height: 20px;
      color: #f4ede8;
    }
    &:hover {
      background: blue;
    }
  }
`;

const AddBlog = () => {
    const [title, setTitle] = useState('');
    const [Desc, setDesc] = useState('');
    const [Error, setError] = useState('');
    const [image, setImage] = useState('');
    const [loader, setLoader] = useState(false);
    const [url, setUrl] = useState("https://i.imgur.com/ndu6pfe.png");

    const handleFiles = (files) => {
        setUrl(files.base64);
        setImage(files?.fileList[0]);
    };

    const Navigate = useNavigate();

    const token = localStorage.getItem('accessToken');

    const AddBlog = () => {
        setLoader(true);
        try {
            const Blog = new FormData();
            Blog.append('title', title);
            Blog.append('image', image);
            Blog.append('discription', Desc);

            instance.post(`admin/post`, Blog).then((response) => {
                console.log(response, 'working');
                const status = response?.data?.status;
                setLoader(false);

                if (status === true) {
                    Swal.fire({
                        title: 'Good job!',
                        text: 'Blog Add SuccessFully!',
                        icon: 'success',
                        button: 'Ok',
                    });
                    Navigate('/dashboard/user');
                    setLoader(false);
                } else {
                    setLoader(false);
                }
            });
        } catch (error) {
            setLoader(false);
            console.log(error?.message);
            Swal.fire({
                title: 'Something Went Wrong',
                text: error?.message,
                icon: 'error',
                dangerMode: true,
            });
        }
    };


    return (
        <>
            <Helmet>
                <title> Add Blog | Assignment Help </title>
            </Helmet>
            <Backdrop sx={{ color: 'red', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loader}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Card style={{ width: '50%', margin: 'auto' }}>
                <CardContent>
                    <h1 color="text.secondary">Add Blog</h1>
                    <Box
                        sx={{
                            width: 500,
                            maxWidth: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        }}
                    >
                        <AvatarInput>
                            <img src={url} alt="Avatar Placeholder" />
                        </AvatarInput>
                        <ReactFileReader
                            fileTypes={[".png", ".jpg"]}
                            base64={true}
                            handleFiles={handleFiles}
                        >
                            <Button variant="contained" as={Button} fullWidth sx={{ backgroundColor: 'red', padding: '16px 10px', marginBottom: '20px' }} startIcon={<CloudUploadIcon icon="eva:plus-fill" />}>
                                Upload Image
                            </Button>
                        </ReactFileReader>
                    </Box>
                    <Box
                        sx={{
                            width: 500,
                            maxWidth: '100%',
                        }}
                    >
                        <TextField
                            fullWidth
                            label="Title"
                            id="fullWidth"
                            placeholder="Enter Title"
                            sx={{ mb: 2 }}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                        <p className="text-danger">{Error?.title}</p>
                    </Box>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '100%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <TextField
                            id="outlined-multiline-static"
                            multiline
                            label="Description"
                            rows={4}
                            placeholder="Enter Description"
                            sx={{ mb: 3 }}
                            onChange={(e) => setDesc(e.target.value)}
                        />
                    </Box>
                </CardContent>
                <CardActions>
                    <Button size="large" variant="contained" sx={{ backgroundColor: '#ff5a3c', my: 2 }} onClick={AddBlog}>
                        Add Blog
                    </Button>
                </CardActions>
            </Card>
        </>
    );
};

export default AddBlog;
